import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';

class DataBaseGroupServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getSelect(params) {
    return this.http.get('select', { params: params });
  }
}

export const DataBaseGroupService = new DataBaseGroupServiceClass({
  api_version: 3,
  resource: 'database-groups'
});
